import {
	Component,
	OnInit,
	Inject,
	ViewChild,
	Input,
	AfterViewInit,
	OnDestroy,
	SimpleChanges,
	OnChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchModule, SearchService, SearchComponent, SearchState } from '@nx-ahs/search';
import { ApplicationModel } from '@nx-ahs/shared/models';
import { PageHeaderComponent, AppSpinnerComponent } from '@nx-ahs/shared/components';
import { Subscription } from 'rxjs';
import { MailService } from '../services/mail.service';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
	selector: 'mail-batch-search',
	templateUrl: './mail-batch-search.component.html',
	styleUrls: ['./mail-batch-search.component.scss'],
	standalone: true,
	imports: [CommonModule, SearchModule, PageHeaderComponent, AppSpinnerComponent]
})
export class MailBatchSearchComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
	@Input()
	public canExport: boolean = true;

	@ViewChild('mailBatchSearch') mailBatchSearch: SearchComponent;

	public loading: boolean = false;
	public searchCustomizedSubscription: Subscription;
	public userSubscription: Subscription;
	public userId: number;
	public iconId: number;
	public app: ApplicationModel;
	public appSubscription: Subscription;
	public mailBatchSearchPromise: Promise<any>;
	private subscriptions: Subscription[] = [];

	constructor(
		private searchService: SearchService,
		@Inject('securityService') private securityService: any,
		public mailService: MailService
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		console.log(changes);
	}

	ngOnInit() {
		// Subscribe to custom view changes
		this.subscriptions.push(
			this.searchService.customViewSaved.subscribe((newState) => {
				this.mailBatchSearch.searchState.displayedColumns = this.mailBatchSearch.createDisplayedColumns(
					this.mailBatchSearch.searchState.definition,
					newState.state
				);
			})
		);

		// Subscribe to user changes since client config metadata may need the userId
		this.subscriptions.push(
			this.securityService.currentUserChanged.subscribe((user) => {
				this.userId = user.userId;
			})
		);

		// If the user already exists then store it
		if (this.securityService.getCurrentUser()) {
			this.userId = this.securityService.getCurrentUser().userId;
		}

		this.subscriptions.push(
			this.mailService.refreshMailBatches.subscribe((result) => {
				if (result) {
					// Run Search automatically
					this.mailBatchSearch.search(false);
				}
			})
		);
	}

	ngAfterViewInit(): void {
		this.mailBatchSearchPromise?.then(() => {});

		// Init icon
		this.iconId =
			this.securityService
				.getCurrentApp()
				.application.clientConfig.layout.menu.find((x) => x.title == 'Mail Batch Search').iconId ?? 396;

		// Set the search data
		this.mailBatchSearch.searchId = this.securityService
			.getCurrentApp()
			.application.clientConfig.layout.menu.find((x) => x.title == 'Mail Batch Search').metadata.searchId;
		this.mailBatchSearch.criteriaValues = {};
		this.mailBatchSearch.customizeKey = 'mail-batch-search';

		// Create new search state
		this.mailBatchSearch.searchState = new SearchState();
	}

	ngOnDestroy() {
		this.subscriptions.forEach((s) => {
			s.unsubscribe();
		});
	}
}
